import useInitializeEmailAdvancedForm from './useInitializeEmailAdvancedForm'
export default useInitializeEmailAdvancedForm
